<ion-badge slot="end" color="{{ iconColor }}">
    <ion-icon size="large" name="{{ iconName }}"></ion-icon>
</ion-badge>
